export enum LanguageCodes {
    de = 'de',
    en = 'en',
    fr = 'fr',
    nl = 'nl'
}
